<div class="w-full">
  <!-- idle / dragover -->
  <label
    *ngIf="state === 'idle' || state === 'dragover'"
    for="receipt-input"
    class="flex flex-col md:flex-row items-center gap-4 md:gap-6 cursor-pointer rounded-xl border border-dashed p-3 md:px-6 md:py-4 transition-colors"
    [class.border-neutrals-500]="state === 'idle'"
    [class.bg-neutrals-100]="state === 'idle'"
    [class.border-primary-400]="state === 'dragover'"
    [class.bg-primary-100]="state === 'dragover'"
  >
    <div
      class="flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-primary-100 shrink-0"
    >
      <ui-icon
        name="upload-file"
        size="32"
        mobile-size="24"
        fill="primary-400"
      ></ui-icon>
    </div>
    <div class="flex flex-col flex-1 text-center md:text-left">
      <ui-paragraph
        type="p16"
        font-weight="semibold"
        text-color="neutrals-900"
        content="Selecciona o arrastra el comprobante aquí"
      />
      <ui-paragraph
        type="p14"
        font-weight="regular"
        text-color="neutrals-600"
        content="Formato JPG, PNG, PDF, JPEG y WEBP. Máximo 10 MB"
      />
    </div>
    <input
      id="receipt-input"
      type="file"
      class="hidden"
      accept=".pdf,.jpg,.jpeg,.png,.webp"
      (change)="onFileInputChange($event)"
    />
  </label>

  <!-- success -->
  <div
    *ngIf="state === 'success'"
    class="flex items-center gap-3 rounded-lg border border-dashed border-neutrals-500 bg-neutrals-100 p-4"
  >
    <div
      class="flex items-center justify-center w-10 h-10 rounded-full bg-success-100 shrink-0"
    >
      <ui-icon name="check-filled" size="20" fill="success-300"></ui-icon>
    </div>
    <div class="flex flex-col flex-1 min-w-0">
      <ui-paragraph
        type="p14"
        font-weight="semibold"
        text-color="neutrals-900"
        content="Comprobante cargado"
      />
      <ui-paragraph
        type="p12"
        font-weight="regular"
        text-color="neutrals-700"
        [content]="selectedFile!.name + ' (' + fileSizeMB + ')'"
      />
    </div>
    <button
      type="button"
      class="text-primary-400 text-xs font-medium shrink-0"
      (click)="removeFile()"
    >
      Eliminar
    </button>
  </div>

  <!-- error -->
  <div
    *ngIf="state === 'error'"
    class="flex items-center gap-3 rounded-lg border border-dashed border-critical-300 bg-critical-100 p-4"
  >
    <div
      class="flex items-center justify-center w-10 h-10 rounded-full bg-critical-100 shrink-0"
    >
      <ui-icon name="warning-outline" size="20" fill="critical-300"></ui-icon>
    </div>
    <div class="flex flex-col flex-1 min-w-0">
      <ui-paragraph
        type="p14"
        font-weight="semibold"
        text-color="critical-300"
        content="Se produjo un error"
      />
      <ui-paragraph
        *ngIf="selectedFile"
        type="p12"
        font-weight="regular"
        text-color="neutrals-700"
        [content]="selectedFile.name + ' (' + fileSizeMB + ')'"
      />
    </div>
    <button
      type="button"
      class="text-critical-300 text-xs font-medium shrink-0"
      (click)="removeFile()"
    >
      Eliminar
    </button>
  </div>

  <!-- helper text -->
  <div class="mt-2">
    <ui-paragraph
      class="text-center"
      type="p14"
      font-weight="regular"
      text-color="neutrals-600"
      content="Es obligatorio subir el comprobante de entrega para hacer el registro válido"
    />
  </div>
</div>
